export default "__VITE_ASSET__Cm7l70ne__"